import React from "react";
import { MessageCircle, Linkedin } from "lucide-react";

export function ShareButtons({ url, title, testid = "share" }) {
  const wa = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
  const li = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={testid}>
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-whatsapp`}
        className="inline-flex items-center gap-2 rounded-lg bg-accent px-5 py-3 text-sm font-semibold text-accent-foreground transition-opacity hover:opacity-90">
        <MessageCircle className="h-4 w-4" /> Share on WhatsApp
      </a>
      <a href={li} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-linkedin`}
        className="inline-flex items-center gap-2 rounded-lg border border-border px-4 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-card">
        <Linkedin className="h-4 w-4" /> LinkedIn
      </a>
    </div>
  );
}
